import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { ReferralPreRegistrationService } from '@mpt-fo/common/core/services/referral-pre-registration.service';
import { CaseInsensitiveParamMap } from '../case-insensitive-param-map';
@Component({
	selector: 'app-referrals-pre-registration-joining',
	templateUrl: './referrals-pre-registration-joining.component.html',
	styleUrls: ['./referrals-pre-registration-joining.component.scss']
})
export class ReferralsPreRegistrationJoiningComponent implements OnInit {
	is404 = false;
	isMobile = false;
	isLoading = true;
	errorMessage = '';
	referralCode: string;
	firstName = '';
	readonly breakPoint = 900;
	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}
	constructor(private route: ActivatedRoute, private referralPreRegistrationService: ReferralPreRegistrationService) { }

	ngOnInit(): void {
		this.setMobile(window.innerWidth);

		this.route.queryParams
			.subscribe((params) => this.handleQueryParamsChanged(new CaseInsensitiveParamMap(params)));

	}

	private handleQueryParamsChanged(paramMap: CaseInsensitiveParamMap): void {
		this.referralCode = paramMap.get('rc');
		this.getPromotterName();
	}

	getPromotterName() {
		this.isLoading = true;
		this.referralPreRegistrationService.getPromotterName(this.referralCode).then(promotterName => {
			this.isLoading = false;
			if (promotterName && promotterName.firstName) {
				this.firstName = promotterName.firstName;
			}
		}).catch((err) => {
			this.isLoading = false;
			this.is404 = ((err?.error?.responseCode || '') as string).startsWith('404');
			this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
		});
	}

	setMobile(browserWidth) {
		this.isMobile = browserWidth <= this.breakPoint;
	}

}
